import clsx from 'clsx';
import React from 'react';
import Depot from '../../_shared/depot';
import { IconChevronDown } from '../../../';
import * as styles from './style.module.css';
import InputField, { shared as inputFieldSharedMethods, } from '../InputField';
const prefix = 'dropdownField';
const DropdownFieldWithoutRef = ({ id, label, hideLabel, errorMessage, supportMessage, testId = `${prefix}-container`, className, fullWidth = false, onClear, ref, ...commonProps }) => {
    // IDs
    const errorMessageId = inputFieldSharedMethods.errorMessageId({ prefix, id });
    // Classes
    const wrapperClasses = clsx(styles.root, { [styles.fullWidth]: fullWidth }, className);
    return Depot.createElement('div', {
        className: wrapperClasses,
        testId,
    }, React.createElement(React.Fragment, null,
        React.createElement(InputField.Label, { htmlFor: id, hideLabel: hideLabel, label: label }),
        React.createElement("div", { className: styles.selectContainer, "data-testid": `${prefix}-selectContainer` },
            React.createElement(InputField.Select, { ...commonProps, "aria-invalid": !!errorMessage, "aria-errormessage": errorMessage ? errorMessageId : '', "data-testid": prefix, errorMessage: errorMessage, id: id }),
            React.createElement(IconChevronDown, { fill: styles.chevronColor, className: clsx(styles.arrowChevron) })),
        React.createElement(InputField.Messages, { prefix: prefix, id: id, errorMessage: errorMessage, supportMessage: supportMessage })));
};
const DropDownField = Depot.withRef(InputField.stateManager(DropdownFieldWithoutRef));
DropDownField.displayName = 'DropDownField';
export default DropDownField;
//# sourceMappingURL=index.js.map